$(document).ready(function () {

    
    $("#togglemenu").find(".mmHaschild").append("<div class=\"navitoggleicon\"></div>");

    $(".navitoggleicon").click(function () {
        var thistoggleicon = $(this);
        var thisul = $(this).parent("li").find("> ul");

        if (thisul.css('display') == 'block') {
            thisul.hide("slow");
            thistoggleicon.removeClass("isopen");
        } else {
            thisul.show("slow");
            thistoggleicon.addClass("isopen");
        }
    });

    $("#togglemenu").find(".mmHaschild.active > ul").addClass("isopen");
    $("#togglemenu").find(".mmHaschild.active > .navitoggleicon").addClass("isopen");

    toggleMobileMenu();

});

function toggleMobileMenu(){
    $(".hamburger.mobile").click(function () {
        if($(this).hasClass("open")){
            $(this).removeClass("open");
            $("#togglemenu").removeClass("expanded");
        } else {
            $(this).addClass("open");
            $("#togglemenu").addClass("expanded");
        }
    });
}

